var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.row),function(position,index){return _c('position',{key:index,class:("col-md-" + (position.width) + " sticky-top"),attrs:{"grid":_vm.grid,"position":position.columnId,"url":_vm.url,"params":_vm.params}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }